// extracted by mini-css-extract-plugin
export default {"section":"JobPreferences_section__XgRac","sectionItem":"JobPreferences_sectionItem__OlSCE","content":"JobPreferences_content__OARv1","modal":"JobPreferences_modal__Yi82L"};